import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";

import FormHeading from "../../UI_Design/FormComponents/Heading/FormHeading";
import GetMasterData from "../../Helper/masterData";
import { deleteSaveEmployment, getEmploymentViaUanData, saveEmployment } from "../../Actions/employmentActions";
import { getData } from "../../Actions/landingAction";
import EmpLoymentQuestionDropdown from "../CandidateEmploymentv2/EmploymentFormFields/EmpLoymentQuestionDropdown";
import EmploymentGapFormWrapper from "../CandidateEmploymentv2/EmploymentGapFormWrapper";
import EmploymentTab from "../CandidateEmploymentv2/TabsAndContent/EmploymentTab";
import { saveEmployementExperienceOption, saveEmplViaUANExperienceOption } from "../../Actions/employementActions_v2";
import EmploymentForm from "../CandidateEmploymentv2/TabsAndContent/EmploymentForm";
import { excludedFields } from "../EmploymentForm/empConstants";
import Loader from "../Common/loader";



const EmpViaUANFormContainer = (props) => {

    const fresherOptions = [
        {
            "id": 1,
            "options": "Yes"
        },
        {
            "id": 2,
            "options": "No"
        }
    ]
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    const { stateOptionspv, currencyOptions, countryCodeOptions } =
        GetMasterData();
    const { loading, employmentViaUANData } = useSelector(
        (state) => state.employmentViaUAN || {}
    );

    const { employmentSaveData, loading: employmentSaveDataLoading } =
        useSelector((state) => state.employmentSaveData);
    const {
        checksDetails,
        clientId,
        showProfilePreview,
        is_employment_validation,
        is_gap_reason,
        referenceNo,
        candidates,
        cross_btn_emp, //for Remove Button
        is_custom_employement, // for add buttton
        employment_config_msg,
        is_disable_emp_question,
    } = employmentViaUANData?.data?.data || {};


    const [tabs, setTabs] = useState([]);
    const [activeTab, setActiveTab] = useState(1); // will store case check id
    const [groupId, setGroupId] = useState(null);
    const [currentStatusDropdownFlag, setCurrentStatusDropdownFlag] = useState(0);
    const [catchIfAllStatusInComplete, setCatchIfAllStatusInComplete] =
        useState(0);
    const [tempEmploymentStatus, setTempEmploymentStatus] = useState(0);
    const [employmentStatus, setEmploymentStatus] = useState(0);
    const [statusDropdownOptions, setStatusDropdownOptions] = useState(fresherOptions);
    const [hasGap, setHasGap] = useState(false);
    const [gapReasonKey, setGapReasonKey] = useState("emp");
    const [gapData, setGapData] = useState({});
    const [finalCaseCheckId, setFinalCaseCheckId] = useState(null);
    const [finalDataToBeSent, setFinalDataToBeSent] = useState({});
    const [etypeErrorPopUp, setEtypeErrorPopUp] = useState(false);
    const [etypeInfo, setEtypeInfo] = useState(null);
    const [etypeShowGap, setETypeShowGap] = useState(null);
    const [showAlertPopUp, setShowAlertPopUp] = useState(false);
    const [showStatusPopUp, setShowStatusPopUp] = useState(false);
    const [showETypeOverlap, setShowETypeOverlap] = useState(false);

    const [allFormInputsField, setAllFormInputFields] = useState({});
    const [allFormInputErrors, setAllFormInputErrors] = useState({});
    const [tillDateChecked, setTillDateChecked] = useState({});

    const [showOtherVerificationSource, setShowOtherVerificationSource] =
        useState({});
    const [otherVerificationSource, setOtherVerificationSource] = useState({});
    const [otherVerificationError, setOtherVerificationError] = useState({});

    useEffect(() => {
        dispatch(getEmploymentViaUanData());
        dispatch(getData()); // to get updated employent form status
        return () => {
            dispatch({ type: "MRL_DOCUMENT_RESET" });
        };
    }, []);

    useEffect(() => {
        if (checksDetails?.length) {
            const tempTabs = checksDetails.map((element, index) => {
                const caseCheckId = element?.case_check_id;
                if (element?.fields?.emp_uan_fresher_question?.field_value === "Fresher" || element?.fields?.emp_uan_fresher_question?.field_value == "1") {
                    setEmploymentStatus(1);
                } else if (element?.fields?.emp_uan_fresher_question?.field_value === "Not a Fresher" || element?.fields?.emp_uan_fresher_question?.field_value == "2") {
                    setEmploymentStatus(2);
                } else {
                    setEmploymentStatus(0);
                }
                return {
                    name: `Employment ${index + 1}`,
                    path: `${element?.case_check_id}`,
                    index: index,
                    content: (
                        <EmploymentForm
                            key={index}
                            index={index + 1}
                            clientId={clientId}
                            checkData={element}
                            countryCodeOptions={countryCodeOptions}
                            showProfilePreview={showProfilePreview}
                            totalTabs={checksDetails?.length}
                            isEmpValidationRequired={is_employment_validation}
                            isGapReason={is_gap_reason}
                            setShowAlertPopUp={setShowAlertPopUp}
                            setETypeShowGap={setETypeShowGap}
                            setEtypeErrorPopUp={setEtypeErrorPopUp}
                            setGapData={setGapData}
                            setFinalCaseCheckId={setFinalCaseCheckId}
                            setFinalDataToBeSent={setFinalDataToBeSent}
                            setHasGap={setHasGap}
                            setGapReasonKey={setGapReasonKey}
                            setEtypeInfo={setEtypeInfo}
                            etypeInfo={etypeInfo}
                            setAllFormInputErrors={setAllFormInputErrors}
                            setAllFormInputFields={setAllFormInputFields}
                            fieldInput={allFormInputsField[caseCheckId] || {}}
                            errorData={allFormInputErrors[caseCheckId] || {}}
                            tillDateChecked={tillDateChecked[caseCheckId]}
                            setTillDateChecked={setTillDateChecked}
                            showOtherVerificationSource={
                                showOtherVerificationSource[caseCheckId]
                            }
                            setShowOtherVerificationSource={setShowOtherVerificationSource}
                            otherVerificationSource={otherVerificationSource[caseCheckId]}
                            setOtherVerificationSource={setOtherVerificationSource}
                            otherVerificationError={otherVerificationError[caseCheckId]}
                            setOtherVerificationError={setOtherVerificationError}
                            saveHandler={saveHandler}
                        />
                    ),
                };
            });
            setTabs(tempTabs);
        }
    }, [
        allFormInputErrors,
        allFormInputsField,
        tillDateChecked,
        candidates,
        showOtherVerificationSource,
        otherVerificationSource,
        otherVerificationError,
    ]);

    useEffect(() => {
        const checkActiveTab = checksDetails?.find((check) => location.pathname.endsWith(check?.case_check_id))
        if (checkActiveTab?.case_check_id) {
            setActiveTab(checkActiveTab?.case_check_id) // refreshing the name tab
        } else if (checksDetails?.length) {
            changeTab(checksDetails[0].case_check_id); // in case of no active tab found first render
        }
    }, [location?.pathname, checksDetails])


    useEffect(() => {

        resetOthersField();
        if (checksDetails?.length) {

            checksDetails.map((element, index) => {
                const caseCheckId = element?.case_check_id;
                let initialInput = {};
                let initialErrorData = {};
                if (element?.fields) {
                    for (let i in element?.fields) {
                        initialInput[i] = element?.fields[i]?.field_value;
                        initialErrorData[i] = false;

                        if (i === "till_date") {
                            const initialTillDateChecked =
                                element?.fields[i].field_value === "1" ? true : false;
                            setTillDateChecked((prevState) => ({
                                ...prevState,
                                [caseCheckId]: initialTillDateChecked,
                            }));
                        }
                    }

                    setAllFormInputFields((prevstate) => ({
                        ...prevstate,
                        [caseCheckId]: initialInput,
                    }));

                    setAllFormInputErrors((prevstate) => ({
                        ...prevstate,
                        [caseCheckId]: initialErrorData,
                    }));
                }
            });
        }
    }, [checksDetails]);

    const resetOthersField = () => {
        setShowOtherVerificationSource({});
        setOtherVerificationSource({});
        setOtherVerificationError({});
    }


    const handleDropdownChangeInternal = (event) => {
        setTabs([]);
        setEmploymentStatus(event?.target?.value);
    };

    const handleNextNavigation = (e) => {
        e?.preventDefault();
        dispatch(saveEmplViaUANExperienceOption({ fresher: employmentStatus, referenceNo }, getGroupInfo));

    };

    const closeGapPopUp = () => {
        dispatch(getEmploymentViaUanData());
        setHasGap(false);
    };

    const handleGapReasonSubmit = (gapReasonData) => {
        // setIsLoading(true);
        let newFinalData = { ...finalDataToBeSent };
        let newGapData = [];
        for (var i in gapReasonData) {
            let obj = {};
            let category = null;
            for (var j in gapReasonData[i]) {
                if (["label", "tenure_to", "tenure_from"].includes(j)) {
                    obj[`gap_${j}`] = gapReasonData[i][j];
                } else {
                    if (j == "category") {
                        category = gapReasonData[i][j];
                    }
                    obj[`${j}`] = gapReasonData[i][j];
                }
            }
            obj["gap_type"] = category;
            newGapData.push(obj);
        }
        newFinalData[finalCaseCheckId]["GapReason"] = newGapData;
        // dispatch(
        //     saveEmployment(
        //         finalCaseCheckId,
        //         newFinalData,
        //         activeTab,
        //         saveEmploymentCallback
        //     )
        // );
    };

    const getGroupInfo = (data) => {
        const groupId = data?.data?.group?.group_id || data?.data?.group;
        setGroupId(groupId);
        setEmploymentStatus(tempEmploymentStatus);
        setTempEmploymentStatus("");
        dispatch(getData());
        if (groupId == 24 || !groupId) {
            navigate(`/case-initiation/check-detail/${referenceNo}/24`); // to render first tab ...conditon written in employmentTab to change the link
            dispatch(getEmploymentViaUanData());
        } else {
            console.log("running line 515");
            setTabs([]);
            if (groupId == "profile_preview") {
                navigate(`/case-initiation/profile-preview/${referenceNo}`);
            } else {
                navigate(`/case-initiation/check-detail/${referenceNo}/${groupId}`);
            }
        }
    };

    const changeTab = (tabNumber) => {
        if (tabNumber) {
            navigate(`/case-initiation/check-detail/${referenceNo}/24/${tabNumber}`);
            setActiveTab(tabNumber);
            window.scroll({ top: 0, left: 0, behavior: "smooth" });
        }
    };

    const handleSubmitForPreview = (e) => {
        e.preventDefault();
        navigate(`/case-initiation/profile-preview/${referenceNo}`);
    };

    const saveHandler = (e, caseCheckId) => {
        e?.preventDefault();
        checkForMandatoryError(caseCheckId);
      };

      const checkForMandatoryError = (caseCheckId, addFlag) => {
        const checkData = checksDetails.find(check => check.case_check_id === caseCheckId)
        const { fields } = checkData || {};
        // const caseCheckId = checkData?.case_check_id;
        let updatedErrorData = {...allFormInputErrors[caseCheckId]};
        let fieldInput = {...allFormInputsField[caseCheckId]};
        for (var i in fields) {
          let isFieldMandatory = fields[i].is_mandatory;
          if (i == "till_date") {
            isFieldMandatory =
            fieldInput["company_date_of_leaving"] &&
            fieldInput["company_date_of_leaving"] != ""
                ? 0
                : 1;
          }
          if (i == "company_name" && showOtherVerificationSource[caseCheckId] == true) {
            if (otherVerificationSource[caseCheckId] == "" || otherVerificationSource[caseCheckId] == null) {
              setOtherVerificationError((prevState) => ({
                ...prevState,
                [caseCheckId]: true,
              }));
            } else {
              setOtherVerificationError((prevState) => ({
                ...prevState,
                [caseCheckId]: false,
              }));
            }
          }
          if (i == "company_date_of_leaving") {
            const isTillDateChecked =
              tillDateChecked[caseCheckId] && tillDateChecked[caseCheckId] == true ? true : false;
            if (isTillDateChecked) {
              isFieldMandatory = 0;
            }
          }
          if(i == "address_of_company" && !(showOtherVerificationSource[caseCheckId] == true)) {
            isFieldMandatory = 0;
            updatedErrorData[i] = false;
          }
          if(i == "company_contact_no" && !(showOtherVerificationSource[caseCheckId] == true)) {
            isFieldMandatory = 0;
            updatedErrorData[i] = false;
          }
          if (isFieldMandatory == 1 && !excludedFields.includes(i)) {
            if (fieldInput[i].trim() == "" || fieldInput[i] == null) {
              updatedErrorData[i] = true;
            }
          }
        }
    
        // setErrorData(updatedErrorData);
        setAllFormInputErrors((prevstate) => ({
          ...prevstate,
          [caseCheckId]: updatedErrorData,
        }));
    
        let isThereAnyError = false;
        for (var i in updatedErrorData) {
          if (updatedErrorData[i] == true && i != "till_date") {
            // setIsLoading(false);
            isThereAnyError = true;
            break;
          }
        }
        if (
          otherVerificationError[caseCheckId]
        ) {
          // setIsLoading(false);
          isThereAnyError = true;
        }
    
        if (isThereAnyError) {
          const errorMsg = addFlag ? "Please fill the current form & then click 'Add Employment'" : "Please fill all required fields.";
          toast.error(errorMsg, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          window.scroll({ top: 0, left: 0, behavior: "smooth" });
          return false;
        }
        if (!isThereAnyError) {
          if(!addFlag) {
            createPayloadForSave(caseCheckId);
          } else {
            return true;
          }
        }
      };

      const createPayloadForSave = (caseCheckId, addFlag) => {
        // setIsLoading(true);
        // const caseCheckId = checkData.case_check_id;
        const checkData = checksDetails.find(check => check.case_check_id === caseCheckId);
        const { fields } = checkData || {};
        let fieldInput = {...allFormInputsField[caseCheckId]};
        let savedDetailsObj = {};
        const currencyMasterData = JSON.parse(localStorage.getItem("currency"));
        const fieldDetails = { ...fields };
        // const caseMobileCodes = mobileCode[caseCheckId] || {}
        for (var i in fieldDetails) {
          if (fieldInput[i] !== "" && fieldInput[i] !== null) {
            savedDetailsObj[`${fieldDetails[i].id}`] = fieldInput[i];
          }
          if (fieldInput[i] === "" && fieldDetails[i].label === "Till Date") {
            savedDetailsObj[`${fieldDetails[i].id}`] = fieldInput[i]; //needs to be done in general way
          }
    
          if (fieldDetails[i].label === "Date of leaving") {
            if (tillDateChecked[caseCheckId] === true) {
              savedDetailsObj[`${fieldDetails[i].id}`] = "";
            }
          }
    
          if (
            fieldDetails[i].label ===
            "Date by when you can provide the reliveing letter"
          ) {
            if (!(tillDateChecked[caseCheckId] && tillDateChecked[caseCheckId] === true)) {
              savedDetailsObj[`${fieldDetails[i].id}`] = "";
            }
          }
          if (fieldDetails[i].label === "Salary Currency") {
            let currencyDt = "";
            if (currencyMasterData?.length) {
              currencyDt = currencyMasterData?.find(
                (currencyData) => currencyData?.label?.currency == fieldInput[i]
              );
              if (currencyDt) {
                savedDetailsObj[`${fieldDetails[i].id}`] =
                  currencyDt?.label?.short_name;
              }
            }
          }
        }
        // setIsLoading(false);
        let finalData = {};
        finalData[`${caseCheckId}`] = savedDetailsObj;
        finalData[`${caseCheckId}`]["group"] = "employment_via_uan_new";
        // finalData[`${caseCheckId}`]["company_contact_no_code"] =
        //   fieldInput.company_contact_no
        //     ? fieldDetails?.company_contact_no?.country_code_value
        //     : "91";
        // finalData[`${caseCheckId}`]["mobile_code_manager"] =
        //   fieldInput.manager_mobile_no ? caseMobileCodes.mobile_code_manager : "91";
        // finalData[`${caseCheckId}`]["mobile_code_manager1"] =
        //   fieldInput.manager_mobile_no1 ? caseMobileCodes.mobile_code_manager1 : "91";
        // finalData[`${caseCheckId}`]["mobile_code_hr"] = fieldInput.hr_mobile_no
        //   ? caseMobileCodes.mobile_code_hr
        //   : "91";
        if (showOtherVerificationSource[caseCheckId] == true) {
          finalData[`${caseCheckId}`]["otherVerificationSource"] =
            otherVerificationSource[caseCheckId];
        }
        // if (showOtherDesignation[caseCheckId] == true) {
        //   finalData[`${caseCheckId}`]["17"] = otherDesignation[caseCheckId];
        // }
        // if (showOtherReasonLeaving[caseCheckId] == true) {
        //   finalData[`${caseCheckId}`]["77"] = otherReasonLeaving[caseCheckId];
        // }
        // if (showOtherLocation[caseCheckId] == true) {
        //   finalData[`${caseCheckId}`]["18"] = otherLocation[caseCheckId];
        // }
        // if(addFlag){
        //   finalData[`${caseCheckId}`].is_final_tab = 0;
        // }
        if(!addFlag) {
            finalData[`${caseCheckId}`]["is_final_tab"] = "1";
            dispatch(
                saveEmployment(
                  caseCheckId,
                  finalData,
                  1,
                  saveEmploymentCallback
                )
              );
        } else {
          return ({
            finalData,
            caseCheckId
          });
        }
      };

      const saveEmploymentCallback = (savedEmployementData) => {
        // debugger;
        if (savedEmployementData) {
          const groupId =
            savedEmployementData?.group?.group_id || savedEmployementData?.group;
          const nextCheckId = savedEmployementData?.nextCheck;
          const findNextCheckIndex = checksDetails?.findIndex(
            (check) => check?.case_check_id == nextCheckId
          );
          if (groupId == "profile_preview") {
            navigate(`/case-initiation/profile-preview/${referenceNo}`);
          } else if (groupId == 4 && nextCheckId) {
            changeTab(nextCheckId);
            setActiveTab(nextCheckId);
            dispatch(getEmploymentViaUanData());
          } else {
            navigate(`/case-initiation/check-detail/${referenceNo}/${groupId}`);
          }
          dispatch(deleteSaveEmployment());
        }
      };


    return (
        <>
        {!!(loading || employmentSaveDataLoading) && <Loader />}
            <div className="" style={{ background: "#F9FAFB" }}>
                <div
                    className="formHeading mb-3 border-bottom"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}
                >
                    <FormHeading
                        heading="Employment"
                        subHeading={
                            !!(
                                employmentStatus
                            )
                                ? employment_config_msg || ""
                                : ""
                            // "Add your highest education degree/certificate/all marksheets."
                        }
                    />
                </div>
                {!hasGap && (
                    <div className="row" style={{
                        background: "white",
                        border: "1px solid #E4E7EC",
                        borderRadius: 8,
                        paddingTop: 26,
                        marginBottom: 20,
                        backgroundSize: "initial",
                        marginLeft: 0,
                        marginRight: 0,
                        maxWidth: !!(is_disable_emp_question && statusDropdownOptions?.length > 1) ? 600 : 500,
                    }}>
                        <div className={`${!!(is_disable_emp_question && statusDropdownOptions?.length > 1) ? "col-lg-9 " : "col-lg-12"} col-md-12 col-sm-12`}>
                            <EmpLoymentQuestionDropdown
                                label="Are you a fresher?"
                                labelStyle={{ color: "#6B7280" }}
                                options={statusDropdownOptions}
                                value={employmentStatus}
                                selected={employmentStatus}
                                // currentSavedEmploymentStatus={candidates?.employment_status}
                                catchIfAllStatusInComplete={catchIfAllStatusInComplete}
                                onChange={handleDropdownChangeInternal}
                                isDisableEmpQuestion={currentStatusDropdownFlag}
                            />
                        </div>
                        {!!(is_disable_emp_question && statusDropdownOptions?.length > 1) && (
                            <div className="emp-status-edit col-auto" style={{ display: "flex" }}>
                                {!!currentStatusDropdownFlag && (
                                    <div className="mb-3">
                                        <button
                                            className="btn btn-edit btn-lg btn-block"
                                            style={{
                                                height: 47,
                                                padding: "10px 18px"
                                            }}
                                            onClick={(e) => {
                                                e?.preventDefault();
                                                setCurrentStatusDropdownFlag(0);
                                            }}
                                        ><FeatherIcon size={16} icon="edit-2" />
                                            {" "}Edit
                                        </button>
                                    </div>
                                )}
                                {!currentStatusDropdownFlag && (
                                    <div className="mb-3">
                                        <button
                                            className="btn btn-outline-secondary btn-lg btn-block"
                                            style={{
                                                height: 47,
                                                padding: "10px 18px"
                                            }}
                                            onClick={(e) => {
                                                e?.preventDefault();
                                                setCurrentStatusDropdownFlag(1);
                                            }}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                )}
                {hasGap && (
                    <EmploymentGapFormWrapper
                        gapData={gapData}
                        closeGapPopUp={closeGapPopUp}
                        handleGapReasonSubmit={handleGapReasonSubmit}
                        gapReasonKey={gapReasonKey}
                        gapName="Employment"
                    />
                )}
                {!!(!!tabs?.length && !hasGap && employmentStatus == "2") ? (
                    <div>
                        <EmploymentTab
                            checksDetails={checksDetails}
                            changeTab={changeTab}
                            setActiveTab={setActiveTab}
                        />
                        {/* <Tabs tabs={tabs} /> */}
                        <Routes>
                            {tabs.map((tab) => (
                                <Route key={tab.path} path={tab.path} element={tab.content} />
                            ))}
                        </Routes>
                    </div>
                ) : (
                    !hasGap && (
                        <>
                            <div className="d-flex">
                                <div className="col-lg-4 col-md-6 col-sm-12">
                                    <button
                                        className="btn btn-primary mb-3"
                                        onClick={(e) => handleNextNavigation(e)}
                                        disabled={!employmentStatus}
                                    >
                                        Continue
                                    </button>
                                </div>
                            </div>
                        </>
                    )
                )}
                {showProfilePreview == 1 && (
                    <div className="row">
                        <div className="col-auto d-flex justify-content-between">
                            <button
                                className="btn btn-primary btn-lg btn-block mt-3"
                                onClick={(e) => handleSubmitForPreview(e)}
                            >
                                {clientId == 459831 ? "Preview" : "Submit for Preview"}
                            </button>
                        </div>
                        <div className="col-auto d-flex justify-content-between mt-4">
                            <small className="text-muted">
                                Please complete all the mandatory fields before final submission
                            </small>
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}

export default EmpViaUANFormContainer;